// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"QuantityNew_actionButton__JeAbx","inputWrapper":"QuantityNew_inputWrapper__G8ayG","inputValue":"QuantityNew_inputValue__JVfgm"};